export default {
  checkout_order_id: 'Checkout Order ID',
  attempts: 'Attempts',
  check_transactions: 'Check Transactions',
  customer_name: 'Customer Name',
  customer_email: 'Customer Email',
  customer_mobile: 'Customer Mobile',
  checkout_details: 'Checkout Details'
}
